import React from "react";
import Icon from "@mdi/react";

export const TitlePage = ({
  ImageTitle,
  titlePage,
  ImageIcon,
  IconTitle,
  ImageIcon1,
  ImageTitle1,
  width,
  height,
}) => {
  return (
    <h1 class="title-main1">
      {ImageIcon ? (
        <img
          src={ImageTitle}
          alt=""
          style={{ width: width, height: height, marginRight: 10 }}
        />
      ) : ImageIcon1 ? (
        <div class="bgIconTitle">
          <Icon path={ImageTitle1} title="" color="#fff" size={1.5} />
        </div>
      ) : (
        <div class="bgIconTitle">
          <Icon path={IconTitle} title="" color="#fff" size={1.5} />
        </div>
      )}
      {titlePage}
    </h1>
  );
};
